/** The input a take's gallery shows as its prompt. The media panel searches the same one. */
export const findPromptInput = (inputs: Record<string, unknown>): [string, unknown] | [] =>
  Object.entries(inputs).find(([key]) => key === 'prompt') ||
  Object.entries(inputs).find(([key]) => key.includes('prompt') && !key.includes('negative')) ||
  [];
